import { isStep1EvaluationComplete } from './evaluationCompletion';

export const assessmentProgress = (row = {}) => {
  if (!isStep1EvaluationComplete(row)) return { label: "평가 전", color: "default" };
  if (Number(row.eval_status) >= 20) return { label: "승인 완료", color: "success" };
  if (Number(row.requires_improve) !== 1) return {
    label: Number(row.direct_risk_score) === 3 ? "기존 조치 유지 · 승인 대기" : "개선 불필요 · 승인 대기",
    color: "info",
  };
  if (Number(row.improve_status) >= 20) return { label: "개선대책 완료 · 승인 대기", color: "info" };
  if (row.improve_plan || Number(row.improve_status) >= 10) return { label: "개선대책 진행 중", color: "warning" };
  return { label: "개선대책 작성 대기", color: "warning" };
};
